import script from "./summaryCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./summaryCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./summaryCalendar.vue?vue&type=style&index=0&id=3967136d&lang=css"

const __exports__ = script;

export default __exports__